import { create } from "zustand";
import { persist } from 'zustand/middleware';

const useStorefrontStore = create(
  persist((set, get) => ({
    organization: null,
    setOrganization: (value) => set({ organization: value }),

    itemCategories: [],
    setItemCategories: (value) => set({ itemCategories: value }),
    itemCategoryById: (id) => get().itemCategories.find((itemCategory) => itemCategory.id == id),

    items: [],
    setItems: (value) => set({ items: value }),
    itemsByCategoryId: (categoryId) => get().items.filter((item) => item.item_category_id == categoryId),
    itemById: (id) => get().items.find((item) => item.id == id),
  }), {
    name: 'storefront-storage', // unique name
  })
);

export default useStorefrontStore;